import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useCookies } from 'react-cookie';

const Styled = {
    Wrap: styled.div`
        width: 100%;
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: #ffffff;
        margin-top: 40px;
    `,
    InfoBox: styled.div`
        width: 90%;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    `,
    ShopInfoBox: styled.div`
        width: auto;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
    `,
    ShopText: styled.p`
        font-size: 24px;
        font-weight: 700;
        margin: 0px;
        font-family: 'PreFont';
    `,
    OtherText: styled.p`
        font-size: 14px;
        color: #939393;
        font-weight: 700;
        font-family: 'PreFont';
        margin: 0px;
    `,
    TableBox: styled.div`
        width: 48px;
        height: 48px;
        border-radius: 6px;
        background-color: #2277F6;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
    TableText: styled.p`
        font-size: 20px;
        color: #ffffff;
        font-family: 'PreFont';
        font-weight: 700;
    `,
};

const Table = (props) => {
    const { RestaurantInfo, TableInfo } = props;
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsFixed(window.scrollY >= 90);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        if ((TableInfo !== null && TableInfo !== undefined) && (RestaurantInfo !== undefined)) {
            if (TableInfo.table_number === undefined) {
                const hasReloaded = sessionStorage.getItem("hasReloaded");
                if (!hasReloaded) {
                    sessionStorage.setItem("hasReloaded", "true");
                    window.location.reload();
                }
            }
        }
    }, [TableInfo, RestaurantInfo]);

    if ((TableInfo !== null && TableInfo !== undefined) && (RestaurantInfo !== undefined)) {
        if (TableInfo.table_number === undefined) {
            return null;
        } else {
            return (
                <Styled.Wrap>
                    <Styled.InfoBox>
                        <Styled.ShopInfoBox>
                            <Styled.ShopText>{RestaurantInfo.titles.KR}</Styled.ShopText>
                            <Styled.OtherText>{RestaurantInfo.sub_names.KR}</Styled.OtherText>
                        </Styled.ShopInfoBox>

                        <Styled.TableBox>
                            <Styled.TableText>{TableInfo.table_number}번</Styled.TableText>
                        </Styled.TableBox>
                    </Styled.InfoBox>
                </Styled.Wrap>
            );
        }
    } else {
        return null;
    }
};

export default Table;
